import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { English } from "./languages/English";
import { Spanish } from "./languages/Spanish";
i18n.use(LanguageDetector).use(initReactI18next).init({
  debug: false,
  fallbackLng: "en",
  resources: {
    en: English,
    es: Spanish
  }
});
export default i18n;
